export default __webpack_public_path__ + "static/FTRegolaNeue-Medium-e7bfaa50c07eac7fddab2d5d3378a64f.woff";